import { INITIALIZE_PACKAGE } from './types';
export function initializePackage(payload) {
    return {
        type: INITIALIZE_PACKAGE,
        payload: payload
    };
}
 
